<template>
    <div class="row-block">
        <ul class="columns-block">
            <li class="column">
                <div class="column-block">
                    <PuSkeleton class="skeleton-input" style="width: 100px"></PuSkeleton>
                    <div class="bottom-part"><!-- order-status -->
                        <div class="bottom-block right-border">
                          <PuSkeleton width="60px" class="skeleton-input"></PuSkeleton>
                          <span style="width: 30px;"></span>
                          <PuSkeleton width="60px" class="skeleton-input"></PuSkeleton>
                        </div>
                    </div>
                </div>
            </li>
            <li class="column">
                <div class="column-block">
                    <span class="order-number">
                      <PuSkeleton width="100px" class="skeleton-input"></PuSkeleton>
                    </span>
                    <div class="bottom-part order-user">
                        <div class="bottom-block right-border">
                            <div class="option-block">
                                <PuSkeleton width="60px" class="skeleton-input"></PuSkeleton>
                                <PuSkeleton width="80px" class="skeleton-input"></PuSkeleton>
                            </div>
<!--                            <div class="user-name" data-toggle="tooltip">-->
<!--                                <PuSkeleton width="60px" class="skeleton-input"></PuSkeleton>-->
<!--                            </div>-->
                        </div>
                    </div>
                </div>
            </li>
            <li class="column">
                <div class="column-block">
                    <div>
<!--                      <div class="option-block">-->
<!--                        <div class="option">-->
<!--                            <PuSkeleton width="60px" class="skeleton-input"></PuSkeleton>-->
<!--                        </div>-->
<!--                        <div class="option">-->
<!--                          <PuSkeleton width="60px" class="skeleton-input"></PuSkeleton>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div class="option-block" style="margin-left: 20px;">-->
<!--                        <div class="option">-->
<!--                          <PuSkeleton width="60px" class="skeleton-input"></PuSkeleton>-->
<!--                        </div>-->
<!--                        <div class="option">-->
<!--                          <PuSkeleton width="60px" class="skeleton-input"></PuSkeleton>-->
<!--                        </div>-->
<!--                      </div>-->

                        <div class="date-block">
                            <PuSkeleton width="60px" class="skeleton-input"></PuSkeleton>
                            <span class="date">
                                <PuSkeleton width="60px" class="skeleton-input"></PuSkeleton>
                            </span>
                        </div>
                        <div class="date-block">
                            <PuSkeleton width="40px" class="skeleton-input"></PuSkeleton>
                            <div style="width:20px;"></div>
                            <span class="date">
                                <PuSkeleton width="60px" class="skeleton-input"></PuSkeleton>
                            </span>
                        </div>
                        <div class="date-block">
                            <PuSkeleton width="40px" class="skeleton-input"></PuSkeleton>
                            <div style="width:20px;"></div>
                            <span class="date">
                                <PuSkeleton width="60px" class="skeleton-input"></PuSkeleton>
                            </span>
                        </div>
                    </div>
                    <div class="bottom-part order-company">
                        <div class="bottom-block right-border">
                            <div class="option-block">
                                <div class="option">
                                    <PuSkeleton width="20px" class="skeleton-input"></PuSkeleton>
                                </div>
                                <div class="result">
                                    <PuSkeleton width="80px" class="skeleton-input"></PuSkeleton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
            <li class="column">
                <div class="column-block">
                    <div class="order-insured">
                        <div>
                            <span>
                                <PuSkeleton width="180px" class="skeleton-input"></PuSkeleton>
                            </span>
<!--                            <span>-->
<!--                                <PuSkeleton width="60px" class="skeleton-input"></PuSkeleton>-->
<!--                            </span>-->
<!--                            <span>-->
<!--                                <PuSkeleton width="60px" class="skeleton-input"></PuSkeleton>-->
<!--                            </span>-->
                        </div>
                    </div>
                    <div class="bottom-part order-company">
                        <div class="bottom-block right-border">
                            <div class="option-block">
                                <div class="option">
                                    <PuSkeleton width="90px" class="skeleton-input"></PuSkeleton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
            <li class="column">
                <div class="column-block">
                    <div>
                        <div class="price-block">
                            <div class="text">
                                <PuSkeleton width="60px" class="skeleton-input"></PuSkeleton>
                            </div>
                            <span class="date">
                                <PuSkeleton width="40px" class="skeleton-input"></PuSkeleton>
                            </span>
                        </div>
<!--                        <div class="price-block">-->
<!--                            <div class="text">-->
<!--                                <PuSkeleton width="60px" class="skeleton-input"></PuSkeleton>-->
<!--                            </div>-->
<!--                            <span class="date">-->
<!--                              <PuSkeleton width="60px" class="skeleton-input"></PuSkeleton>-->
<!--                            </span>-->
<!--                        </div>-->
                    </div>
                    <div class="bottom-part">
                        <div class="bottom-block">
                            <span class="option image">
                                <PuSkeleton width="100px" class="skeleton-input"></PuSkeleton>
                            </span>
<!--                            <span class="ml-4 option image">-->
<!--                                 <PuSkeleton width="126px" class="skeleton-input"></PuSkeleton>-->
<!--                            </span>-->
                        </div>
                    </div>
                </div>
            </li>
            <li class="column">
                <div class="column-block">
                    <div>
                        <div class="price-block">
                            <div class="text">
                                <PuSkeleton width="50px" class="skeleton-input"></PuSkeleton>
                            </div>
                            <span class="date">
                                <PuSkeleton width="20px" class="skeleton-input"></PuSkeleton>
                            </span>
                        </div>
                        <div class="price-block">
                            <div class="text">
                                <PuSkeleton width="30px" class="skeleton-input"></PuSkeleton>
                            </div>
                            <span class="date">
                                <PuSkeleton width="20px" class="skeleton-input"></PuSkeleton>
                            </span>
                        </div>
                        <div class="price-block">
                            <div class="text">
                                <PuSkeleton width="50px" class="skeleton-input"></PuSkeleton>
                            </div>
                            <span class="date">
                                <PuSkeleton width="20px" class="skeleton-input"></PuSkeleton>
                            </span>
                        </div>
                    </div>
                    <div class="bottom-part">
                        <div class="bottom-block">
                            <span class="option image">
                                <PuSkeleton width="40px" class="skeleton-input"></PuSkeleton>
                            </span>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>


<script>
import {orderMixin} from "@/mixin";
import {MoreOptions} from "@/views/history/components/index";

export default {
    name: 'RowBlockSkeleton',
}
</script>
